import z from "zod";

const translationPath = "page.settings.crm.sendLimitDiaries.errors.";

const ticketServiceSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
  },
  { invalid_type_error: translationPath + "ticket_service" }
);

const ticketAutomationsSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
    code: z.string().optional().nullable(),
  },
  { invalid_type_error: translationPath + "ticket_service" }
);

export const sendLimitDiariesSchema = z
  .object({
    enable: z.boolean(),
    name: z.string().min(1, { message: translationPath + "name" }),
    ticketService: ticketServiceSchema,
    startDate: z.date({ invalid_type_error: translationPath + "start_date" }),
    endDate: z.date({ invalid_type_error: translationPath + "end_date" }),
    valueLimit: z.string().min(1, {
      message: translationPath + "value_limit",
    }),
    alertMail: z.string().min(1, {
      message: translationPath + "alert_mail",
    }),
    ticketAutomations: z.array(ticketAutomationsSchema).nullish(),
    description: z.string().nullish(),
  })
  .superRefine((val, ctx) => {
    if (val.endDate < val.startDate) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["endDate"],
        message: translationPath + "end_date_less",
      });
    }
  });

export type TSendLimitDiaries = z.infer<typeof sendLimitDiariesSchema>;
